document.addEventListener('DOMContentLoaded', function() {
  
    var button = document.querySelector('.accordion-content a[href="/pages/jersey-sizing-chart-new"]');
    
    if (button) {
        
        button.addEventListener('click', function(event) {
            event.preventDefault();
            console.log("logged");
            var modal = document.querySelector('.product-modal');
            if (modal) {
                modal.style.display = 'block';
                modal.style.opacity = 1;
            }
        });
    }
});